<template lang="pug">
  button.button-facebook(@click="onClick")
    img.icon(src="../../../../../assets/images/sns/Facebook_Logo_Secondary.png")
    span.text {{ text }}
</template>

<script>
  export default {
    name: 'ButtonFacebook',
    props: {
      text: {
        type: String,
        required: true,
        default: '',
      },
      href: {
        type: String,
        required: true,
        default: '',
      },
    },
    data() {
      return {
      }
    },
    computed: {
    },
    methods: {
      onClick() {
        location.href = this.href
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../assets/stylesheets/v1/styles";

  .button-facebook {
    height: 40px;
    padding: 10px 12px;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    outline: none;
    border: none;
    background: #1877F2;
    color: $white;
    display: flex;
    justify-content: center;
    align-items: center;
    .icon {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
    .text {
      font-family: $font-family-sans;
      font-weight: $font-weight-regular;
      font-style: $font-style-not-italic;
      line-height: $line-height-none;
      // @include font-size(sm);
      font-size: 16px;
    }
  }
</style>
